import axios from "axios";
import { toast } from "react-toastify";
import ApiConfig from "../config/ApiConfig";
import { errorMessage } from "../lib/helper";
import {
  setAllPropertyTypesData,
  setAllPropertyTypesDataLoading,
  setAllPropertyTypesDataError,
  setPropertyCategoryByTypeData,
  setPropertyCategoryByTypeDataLoading,
  setPropertyCategoryByTypeDataError,
  setPropertySubCategoryData,
  setPropertySubCategoryDataLoading,
  setPropertySubCategoryDataError,
} from "../redux/userDashboard";
import { STATUS_200, STATUS_300 } from "../data/constants";

export const GetAllPropertyTyoes = (langParam) => {
  return async (dispatch) => {
    try {
      dispatch(setAllPropertyTypesDataLoading(true));
      const resp = await axios.get(`${ApiConfig.allPropertyTypes}?lang=${langParam}`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setAllPropertyTypesData(resp?.data?.data));
        dispatch(setAllPropertyTypesDataLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setAllPropertyTypesDataError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setAllPropertyTypesDataLoading(false));
    }
  };
};

export const GetPropertyCategoryByType = (langParam) => {

    return async (dispatch) => {
      try {
        dispatch(setPropertyCategoryByTypeDataLoading(true));
        const resp = await axios.get(
          `${ApiConfig.allPropertyCategory}?lang=${langParam}`
        );
        if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
          dispatch(setPropertyCategoryByTypeData(resp?.data?.data));
          dispatch(setPropertyCategoryByTypeDataLoading(false));
        } else {
          throw resp;
        }
      } catch (e) {
        dispatch(
          setPropertyCategoryByTypeDataError({
            isError: true,
            message: errorMessage(e),
          })
        );
        toast.error(errorMessage(e), {
          autoClose: 2000,
        });
        dispatch(setPropertyCategoryByTypeDataLoading(false));
      }
    };

};

// export const GetPropertySubCategory = (payload) => {
//     return async (dispatch) => {
//       try {
//         dispatch(setPropertySubCategoryDataLoading(true));
//         const resp = await axios.get(
//           `${ApiConfig.propertySubCategory}/2`
//         );
//         if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
//           dispatch(setPropertySubCategoryData(resp?.data?.data));
//           dispatch(setPropertySubCategoryDataLoading(false));
//         } else {
//           throw resp;
//         }
//       } catch (e) {
//         dispatch(
//           setPropertySubCategoryDataError({
//             isError: true,
//             message: errorMessage(e),
//           })
//         );
//         toast.error(errorMessage(e), {
//           autoClose: 2000,
//         });
//         dispatch(setPropertySubCategoryDataLoading(false));
//       }
//     };
// };

export const GetPropertySubCategory = (payload, langParam = 1) => {
  if (payload !== undefined) {
    return async (dispatch) => {
      try {
        dispatch(setPropertySubCategoryDataLoading(true));
        const resp = await axios.get(
          `${ApiConfig.propertySubCategory}/${payload}?lang=${langParam}`
        );
        if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
          dispatch(setPropertySubCategoryData(resp?.data?.data));
          dispatch(setPropertySubCategoryDataLoading(false));
        } else {
          throw resp;
        }
      } catch (e) {
        dispatch(
          setPropertySubCategoryDataError({
            isError: true,
            message: errorMessage(e),
          })
        );
        toast.error(errorMessage(e), {
          autoClose: 2000,
        });
        dispatch(setPropertySubCategoryDataLoading(false));
      }
    };
  }
};

export const PostNewProperty = async (payload, extraConfig) => {
 let userDetail=JSON.parse(localStorage?.getItem("user"));
//  alert(  `Congratulations ${userDetail?.first_name} !! You have Successfully logged In.`)
  if (payload !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.postNewProperty}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(
          `Congratulations ${userDetail?.first_name} !! You have Successfully Created a new property`,
          {
            autoClose: 2500,
            className: "toast-message",
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return false;
    }
  }
};
